export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: string;
  features: string[];
  mode: 'payment' | 'subscription';
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_SYtE6QRjoa5POi',
    priceId: 'price_1RdlReGBMYNSXKUMsAiWNRZg',
    name: 'Lucky 10 Pack',
    description: 'Get 10 Premium Spins',
    price: '$0.99',
    features: ['Lucky Multipliers', '10 Premium Spins'],
    mode: 'payment',
  },
  {
    id: 'prod_lucky50',
    priceId: 'price_lucky50',
    name: 'Lucky 50 Pack',
    description: 'Best Value - High Roller Mode!',
    price: '$3.99',
    features: ['Lucky Multipliers', '50 Premium Spins', 'Exclusive Rewards'],
    mode: 'payment',
  },
  {
    id: 'prod_coins_100',
    priceId: 'price_coins_100',
    name: '100 Coins',
    description: 'One-time purchase',
    price: '$1.00',
    features: ['100 Coins'],
    mode: 'payment',
  },
  {
    id: 'prod_unlimited_subscription',
    priceId: 'price_unlimited_subscription',
    name: 'Unlimited Coins',
    description: 'Monthly subscription',
    price: '$5.00',
    features: ['Unlimited Coins', 'Monthly Billing'],
    mode: 'subscription',
  },
];